import React from 'react';
import style from './Cell.module.scss';

// eslint-disable-next-line react/prop-types
const Cell = ({ children }, ...rest) => <div className={style.cell}>{children}</div>;

export default Cell;
